import snakecase from "snakecase-keys";

export const FILTERS_SEPARATOR = ",";

export const OPERATORS = {
  EQUALS: ":",
  EQ: "=",
  LESS_THAN: "<",
  GREATER_THAN: ">",
  LESS_OR_EQUAL: "«",
  GREATER_OR_EQUAL: "»",
  LIKE: "~",
  STARTS_WITH: "^",
};

/**
 * Another way top build search query string.
 * @param search - the search object
 * @param rewrites - object that describes the overwrites that needs to be done.
 * @returns {string} - str
 * Good example can be found in src/modules/data/sagas/data-file-archive/files.js
 * in the onGetDataFileArchive() generator function
 */

export const transformSearchQuery = (search: {}, rewrites: {}) => {
  let result = "";

  for (let prop in search) {
    if (rewrites[prop] && search[prop]) {
      result += `${rewrites[prop].name}${rewrites[prop].operator}${search[prop]}`;
      result += `${FILTERS_SEPARATOR}`;
    }
  }
  if (result.length > 0) {
    result = result.substring(0, result.length - 1);
  }
  return result;
};

/**
 * Transforms Object filters to string
 * suitable for the API
 * Good example of using it is onGetOutstandingTasks
 * @param {object} filters
 * @returns {string}
 */
export const transformFilters = (filters, operators = {}) => {
  const filterEntries = Object.entries(snakecase(filters));

  const formattedEntries = filterEntries
    .map(entry => {
      if (typeof entry[1] === "string") {
        entry[1] = entry[1].replace(/[,:<>«»~^]/g, "");
      }
      return entry;
    })
    .filter(entry => entry[0] && entry[1] !== undefined && entry[1] !== null)
    .map(item => {
      const separator = operators[item[0]] || OPERATORS.EQUALS;
      if (!!item[1].join) return item[1].map(itm => item[0] + separator + itm).join(",");
      return item.join(separator);
    });
  return formattedEntries.join(FILTERS_SEPARATOR);
};

type FilterInterface = $Exact<{
  name: string,
  value: string,
  operator?: string,
}>;

/*
*	This method intend to replace transformFilters method above
*	accept array of objects that contains param name and it value
*	can pass same param name with different values if the API endpoint support it
*	can specify custom operator for API endpoint specific
*	EXAMPLE:
*	const getDataFilesDefaultFilters = [
  {
    name: "status",
    value: DATA_FILE_STATUSES.PENDING,
  },
  {
    name: "status",
    value: DATA_FILE_STATUSES.VALIDATING,
    operator: ">"
  },
  {
    name: "status",
    value: DATA_FILE_STATUSES.VALIDATION_FAILED,
    operator: "?"
  },
];
*/
export const transformFilter = (filters: Array<FilterInterface>) => {
  return filters.map(f => `${f.name}${f.operator || ":"}${f.value}`).join();
};
